interface IProps {
  height: string;
  isLeft: boolean;
}

export default function HorizontalTabScrollGradient({height, isLeft}: IProps) {
  return (
    <div
      className={cn(
        'top-0 w-18 z-navigationBarPlus1 absolute',
        isLeft ? 'left-0' : 'right-0'
      )}
      style={{
        height,
        background: `linear-gradient(to ${
          isLeft ? 'right' : 'left'
        }, rgb(var(--background)) 0, rgba(var(--background),0) 100%)`,
      }}
    />
  );
}
